import { type InferType, number, object, string } from "yup";

export const candidateSchema = object({
  _id: string().required(),
  firstName: string(),
  lastName: string().required(),
  profileId: number().required(),
});

export type TCandidateResolver = InferType<typeof candidateSchema>;
